import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    menu: {
      minWidth: '13.5rem',
      backgroundColor: '#f0f0f0',

      '& > ul > li': {
        fontSize: '1.4rem',
      },
    },

    dialogActions: {
      justifyContent: 'space-between',

      '& > button': {
        margin: '1rem',
        width: '100%',
      },
    },
  }),
)
